<template>
  <section class="worth" name="worth">
    <div class="container">
      <a-typography-title :level="1"
                          data-aos="fade-down">
        What values does our superior the AI application platform of leading next-generation Serverless technology bring to enterprises?
      </a-typography-title>
      <a-row :gutter="[40,20]"
             data-aos="fade-up">
        <a-col v-for="(item,index) in expand.list"
               :xs="24" :md="12" :xl="8">
          <div class="item" :class="`i_${index+1}`">
            <a-typography-title :level="5">
              {{ item.title }}
            </a-typography-title>
            <a-typography-paragraph>
              <p>{{ item.sub }}</p>
              <span v-for="v in item.text">
                {{ v }}
              </span>
            </a-typography-paragraph>
          </div>
        </a-col>
      </a-row>
    </div>
  </section>
</template>

<script lang="ts" type="text/tsx">
import { DataInterface } from '@interface/public';

export default {
  name: 'home_worth',
  data(): DataInterface {
    return {
      expand: {
        list: [
          {
            title: 'No transformation',
            sub: 'Provide patent technology for non-invasive log collection, ' +
              'enabling developers to be language-independent, ' +
              'without the need for framework adaptation or code modification, ' +
              'simply by submitting the Release code, ' +
              'you can build a distributed self-governed system with low cost that possesses automatic scaling, ' +
              'metered billing, ' +
              'and fault self-healing capabilities.',
            text: []
          },
          {
            title: 'No operation and maintenance',
            sub: 'Automate everything from deployment to release, ' +
              'performance, ' +
              'and stability governance. ' +
              'Developers no longer need to configure features such as log collection, ' +
              'compute specifications, ' +
              'or compute scale, ' +
              'reducing over 90% of manual operations, ' +
              'configurations, ' +
              'and releases.',
            text: []
          },
          {
            title: 'Lower costs',
            sub: 'Fully automated end-to-end process, ' +
              'based on patented stress testing technology, ' +
              'automatically identifies the lowest cost computing power resource specifications, ' +
              'implements highly elastic and on-demand payment, ' +
              'always maintains high utilization of computing power resources, ' +
              'and optimizes cloud resource.',
            text: []
          }
        ]
      }
    };
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@image: '@{src_image}overseas/home/';

.worth {
  overflow: hidden;
  position: relative;
  padding: 0 @padding;
  background: @color_white;
  
  .container {
    position: relative;
    max-width: @grid_xl;
    padding: @space 0;
    margin: 0 auto;
    .borderBox();
    text-align: center;
  }
}

h1.ant-typography {
  margin: 0;
  .font(center, @title, @color_12, @title, true);
}

.ant-row {
  margin: @margin 0 0;
}

.item {
  @style_1: fade(@color_white, 50), @color_white;
  @style_2: transform @time, box-shadow @time;
  overflow: hidden;
  position: relative;
  min-height: 450px;
  padding: 0 30px;
  .gradientLinear(0deg, @style_1);
  border: 2px solid @color_14;
  border-radius: 8px;
  .transition(@style_2);
  
  .loop(@i) when (@i<=3) {
    &.i_@{i} {
      &::before {
        .bg('@{image}worth_icon_@{i}.png', 250px, 180px, true);
      }
    }
    .loop(@i+1);
  }
  .loop(1);
  
  &:hover {
    .transform(translateY(-5px));
    .shadow(0 15px 25px fade(#6E778B, 20));
  }
  
  &::before {
    content: '';
    display: block;
    margin: 0 auto;
    .transform(translateX(20px));
  }
  
  h5.ant-typography {
    .font(center, @text_big, @color_12, @text_big, true);
  }
  
  div.ant-typography {
    overflow: hidden;
    margin: @margin_mo 0 0;
    
    p {
      margin: 0;
      .font(left, @text+5px, @color_12, @text);
    }
    
    span {
      display: block;
      position: relative;
      padding-left: 15px;
      .font(left, @text+5px, @color_12, @text);
      
      &:nth-child(2) {
        margin: 5px 0 0;
      }
      
      &::before {
        content: '';
        display: block;
        .position(absolute, 8px, auto, auto, 0);
        width: 5px;
        height: 5px;
        background: @color_10;
        border-radius: 50%;
      }
    }
  }
}

@media screen and (max-width: -1px+@grid_xl) {
  .item {
    min-height: auto;
    padding: 20px;
  }
}

@media screen and (max-width: -1px+@grid_md) {
  .worth {
    .container {
      padding: @space_mo 0;
    }
  }
  
  h1.ant-typography {
    .font(center, @title_mo+@line_mo, @color_12, @title_mo, true);
  }
  
  .ant-row {
    margin: @margin_mo 0 0;
  }
  
  .item {
    @style: 0.5;
    
    .loop(@i) when (@i<=3) {
      &.i_@{i} {
        &::before {
          .bg('@{image}worth_icon_@{i}.png', 250px*@style, 180px*@style, true);
        }
      }
      .loop(@i+1);
    }
    .loop(1);
    
    &::before {
      .transform(translateX(10px));
    }
    
    h5.ant-typography {
      .font(center, @text_big_mo, @color_12, @text_big_mo, true);
    }
    
    div.ant-typography {
      min-height: auto;
      
      p {
        margin: 0;
        .font(left, @text_mo+5px, @color_12, @text_mo, true);
      }
      
      span {
        .font(left, @font_7+5px, @color_13, @font_7);
      }
    }
  }
}
</style>